document.addEventListener('DOMContentLoaded', ()=>{
  
  const hook = setInterval(()=>{
    let hulkDiv = document.querySelector('.hulkapps_option_set');
    if (hulkDiv) {

      clearInterval(hook);

      const checkbox = document.querySelector(".hulk-fee input[type='checkbox']");
      
      let lastQuantity = getCurrentQuantity();

      function getCurrentQuantity() {
        const quantityInput = document.querySelector("quantity-selector-component input[name='quantity']");
        return quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      }

      function isLogoOptionSelected() {
        const logoRadio = document.querySelector('.hulk-logo .hulkapps_option_value label:nth-child(2) input[type="radio"]');
        return logoRadio ? logoRadio.checked : false;
      }

      function updateCheckboxState() {
        if (!checkbox) return;
        
        const currentQuantity = getCurrentQuantity();
        const logoSelected = isLogoOptionSelected();
        
        const shouldBeChecked = logoSelected && currentQuantity < 2;
        
        if (checkbox.checked !== shouldBeChecked) {
          checkbox.checked = shouldBeChecked;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      function handleQuantityChange() {
        const currentQuantity = getCurrentQuantity();
                
        if (currentQuantity === lastQuantity) return;
        
        updateCheckboxState();
        
        lastQuantity = currentQuantity;
      }

      document.body.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]') && e.target.closest('.hulk-logo .hulkapps_option_value')) {
          updateCheckboxState();
        }
      });

      document.body.addEventListener('input', (e) => {
        if (e.target.matches("quantity-selector-component input[name='quantity']")) {
          handleQuantityChange();
        }
      });

      document.body.addEventListener('change', (e) => {
        if (e.target.matches("quantity-selector-component input[name='quantity']")) {
          handleQuantityChange();
        }
      });

      document.body.addEventListener('click', (e) => {
        if (e.target.closest('quantity-selector-component') || 
            e.target.matches('.quantity-minus') ||
            e.target.matches('.quantity-plus') ||
            e.target.matches('[class*="quantity"]')) {
          setTimeout(() => {
            handleQuantityChange();
          }, 100);
        }
      });

      setTimeout(() => {
        updateCheckboxState();
      }, 500);

    }
  }, 150);
  
  setTimeout(()=>{
    clearInterval(hook);
  }, 10000);
});